var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3032_37588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29753 10.38C10.5511 9.39962 11.3574 7.87283 11.3574 6.15854C11.3574 3.20006 8.96673 0.806757 6.00824 0.802739C3.04574 0.798722 0.643066 3.19738 0.643066 6.15854C0.643066 7.83533 1.41316 9.33131 2.61985 10.313C2.66673 10.3505 2.73503 10.3425 2.77253 10.2956L3.30021 9.61926C3.33637 9.57372 3.32833 9.5081 3.28414 9.4706C3.17566 9.38221 3.07119 9.28712 2.97075 9.18667C2.57916 8.79645 2.26713 8.33386 2.052 7.82462C1.827 7.29828 1.7145 6.73712 1.7145 6.15854C1.7145 5.57997 1.827 5.01881 2.05066 4.49113C2.26628 3.98086 2.57566 3.52283 2.96941 3.12908C3.36316 2.73533 3.82119 2.42595 4.33146 2.21033C4.86048 1.98667 5.42164 1.87417 6.00021 1.87417C6.57878 1.87417 7.13994 1.98667 7.66762 2.21033C8.17789 2.42595 8.63592 2.73533 9.02967 3.12908C9.42342 3.52283 9.7328 3.98086 9.94842 4.49113C10.1721 5.01881 10.2846 5.57997 10.2846 6.15854C10.2846 6.73712 10.1721 7.29828 9.94842 7.82595C9.73329 8.3352 9.42126 8.79778 9.02967 9.18801C8.90512 9.31256 8.77387 9.42908 8.63726 9.53622L8.09217 8.83846C8.07983 8.8225 8.06324 8.81036 8.04431 8.80342C8.02537 8.79647 8.00486 8.79502 7.98513 8.79922C7.9654 8.80341 7.94726 8.81309 7.93279 8.82714C7.91832 8.84119 7.90811 8.85904 7.90333 8.87863L7.37298 11.051C7.35691 11.1179 7.4078 11.1835 7.4761 11.1835L9.71271 11.1943C9.80244 11.1943 9.85334 11.0911 9.79708 11.0215L9.29753 10.38Z",
    fill: "current",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3032_37588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.753a9eb08bdb9b4888268f9fa81fb953.svg";
export { ForwardRef as ReactComponent };